// extracted by mini-css-extract-plugin
export default {"completed":"ActivityFooter_completed__HhwP+","success-button":"ActivityFooter_success-button__rR+6f"};